import React, { useEffect, useId, useState } from "react";
import { INPUT, LABEL, BTN_GHOST, BUTTON_RESET } from "../../styles";
import { youtubeSource } from "../../shared/youtube";
import { getVideoSource, saveVideoSource } from "../../services/videoSources";

function VideoSettingsForm({ video }) {
  const fieldId = useId();
  const [selection, setSelection] = useState("auto");
  const [notice, setNotice] = useState("");
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    let live = true;
    getVideoSource(video.videoId).then((source) => {
      if (!live) return;
      if (!["auto", "owned", "external"].includes(source.selection)) {
        setLoading(false);
        setMessage("Não foi possível carregar a configuração. Reabra a aula para tentar novamente.");
        return;
      }
      setLoaded(true);
      setSelection(source.selection);
      setNotice(source.notice || "");
      setLoading(false);
    });
    return () => { live = false; };
  }, [video.videoId]);
  const save = async () => {
    setSaving(true);
    setMessage("");
    try {
      await saveVideoSource(video.videoId, { selection, notice });
      setMessage("Configuração do vídeo salva.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Não foi possível salvar. Tente novamente.");
    } finally { setSaving(false); }
  };
  return (
    <div style={{ display: "grid", gap: 8, marginTop: 12 }}>
      <label htmlFor={fieldId} style={LABEL}>Apresentação do vídeo</label>
      <select id={fieldId} style={INPUT} value={selection} disabled={loading || saving || !loaded}
        onChange={(event) => { setSelection(event.target.value); setMessage(""); }}>
        <option value="auto">Identificar automaticamente pelo canal</option>
        <option value="owned">Vídeo próprio — reproduzir no site</option>
        <option value="external">Vídeo de terceiros — abrir no YouTube</option>
      </select>
      {selection === "external" && <>
        <label htmlFor={`${fieldId}-notice`} style={LABEL}>Aviso para o aluno (opcional)</label>
        <textarea id={`${fieldId}-notice`} style={{ ...INPUT, minHeight: 80 }} maxLength={1000}
          value={notice} onChange={(event) => { setNotice(event.target.value); setMessage(""); }} />
      </>}
      <small>A escolha vale para este vídeo em todas as aulas. Sem aviso personalizado, usamos a recomendação padrão.</small>
      <button type="button" disabled={loading || saving || !loaded} onClick={save}
        style={{ ...BUTTON_RESET, ...BTN_GHOST, justifySelf: "start" }}>
        {saving ? "Salvando…" : "Salvar configuração do vídeo"}
      </button>
      {message && <small role="status">{message}</small>}
    </div>
  );
}

export function VideoSourceSettings({ src }) {
  const raw = String(src || "").match(/<iframe[^>]*src=["']([^"']+)["']/i)?.[1] || src;
  const video = youtubeSource(raw);
  return video?.videoId ? <VideoSettingsForm key={video.videoId} video={video} /> : null;
}
